export default __webpack_public_path__ + "static/media/menu-button.209b5fb4.svg";